import React from 'react'
import { AiAbout } from './AiAbout'
import { AiShowcase } from './AiShowcase'
import { AiTrial } from './AiTrial'

export const AiSection: React.FC = () => {
    return (
        <div className="w-full lg:w-[940px] p-4 md:p-0 self-center">
            <AiAbout />
            <AiShowcase />
            <AiTrial />
        </div>
    )
}
